const formatDate = ( val ) => {
    if (typeof val != 'undefined') {
        var dateValue = new Date(val);
        return (
            new Intl.DateTimeFormat("en-GB", {
                year: "numeric",
                month: "short",
                day: "2-digit"
            }).format(dateValue)
        );
    }
}

const dateFormatter = (val) => {
    if (val != null) {
        var dateValue = new Date(val);
        return (
            new Intl.DateTimeFormat("en-GB", {
                year: "numeric",
                month: "short",
                day: "2-digit"
            }).format(dateValue)
        );
    } else {
        return "";
    }
};

export { formatDate, dateFormatter }